import React, { useEffect } from 'react';
import ProcessingStatusButton from './processing-status-button';
import { useGetPaginatedActivityStatus } from 'api/baker';
import { isDevEnvironment } from 'shared';
import { useQueryClient } from '@tanstack/react-query';

// for local dev only, this is not used in deployed frontends. you may provide any valid activity id
// 22 activities (2 pages of 10 + 2) to allow pagination testing locally
const MOCK_ACTIVITY_LIST = [
    '34ca0a39-cc6a-4a2a-ad79-9c0316c5139f',
    '5aee6b26-768d-45ff-bdd3-669d0b8f19f7',
    '7f00b666-f5b6-4110-b4e3-6b1f81e26876',
    '9a1122a0-27ae-474c-8796-56a9d3028672',
    'bb7b3894-1b4d-4bb7-a35c-eb0ca3a596e3',
    '3f59528e-6063-4f2e-a6fd-aeb232a66b66',
    '7728034b-3d8f-4940-924d-2cb826bec330',
    '19e09e74-59ac-48fd-ad86-9b08079da321',
    '8a085a9d-7e17-4205-b090-d9c7153443bb',
    'b190e4a3-a0c9-4877-91bf-78edb5abe00b',
    'efdab5ad-b250-4f7a-bd58-29d3dccee66e',
    'fe1b68ea-c2fc-4fa4-8ccc-2a75c2039d29',
    'dd0d9fb0-2bd7-4d95-ad79-1a3911fab84d',
    '750503be-76a6-4850-824d-dad0211960c7',
    'c019c42b-b59a-41f1-ae01-6ebf2ff83546',
    'f924d11d-0d9a-4204-b60b-61ada0c95231',
    'd2c7aa65-4a99-417f-b46e-1f07722164ca',
    '84d46820-8c24-4ee2-9c2e-c8c87c0b644e',
    '23f114f8-f770-4a93-afd3-b4f25503fcc4',
    'ad6a108e-b1c1-4892-80b1-3620809aca76',
    'bd78e800-4f91-4c38-a2f0-efc83c59c297',
    '1db7b03d-0ae6-4025-a45e-5369d61fa94a',
];

const MemoizedProcessingStatusButton = React.memo(ProcessingStatusButton, (prev, next) => {
    return JSON.stringify(prev.activityStatuses) === JSON.stringify(next.activityStatuses); // prevents re-renders when the activitiesData changes reference rather than its actual contents
});

export const ActivityStatusContainer: React.FC = () => {
    const queryClient = useQueryClient();
    const {
        statuses: activityStatuses,
        fetchNextPage,
        hasNextPage,
        isFetchingNextPage,
    } = useGetPaginatedActivityStatus(isDevEnvironment, MOCK_ACTIVITY_LIST);

    useEffect(() => {
        if (activityStatuses && activityStatuses.length > 0) {
            // marks the athlete statuses as "old" and forces any open accordions to refetch
            queryClient.invalidateQueries({
                queryKey: ['activity_athletes_status'],
                type: 'active',
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [JSON.stringify(activityStatuses), queryClient]);

    return (
        <MemoizedProcessingStatusButton
            activityStatuses={activityStatuses}
            fetchNextPage={fetchNextPage}
            hasNextPage={hasNextPage}
            isFetchingNextPage={isFetchingNextPage}
        />
    );
};
